
import store from "../store";
import { addNewMessageToStore } from "../redux/tdlibSlice";
import { DEBUG } from "../../../config";
import { getGlobal } from "../../../global";

export async function updateMessagesFirstLoad() {
    const global = getGlobal()
    const messages = global.messages;
    let count = 0
    if (messages) {
        const chatIds = Object.keys(messages.byChatId)
        chatIds.forEach(chatId => {
            const byChatId = messages.byChatId[chatId]
            const msgIds = Object.keys(byChatId.byId)
            msgIds.forEach(id => {
                const msg = byChatId.byId[id]
                count++;
                store.dispatch(addNewMessageToStore({ newMessage: msg }))
            })
        })
    }
    if (DEBUG)
        console.log(`messages count:${count}`)
}